import { useHeardiversaryConfetti } from './useHeardiversaryConfetti'

interface Props {
  firstName: string
  ordinal: string
}

export const HeardiversaryHeader = ({ firstName, ordinal }: Props) => {
  const { emojiRef, containerRef } = useHeardiversaryConfetti()

  return (
    <span>
      {`Happy ${ordinal} Heard-iversary, ${firstName}! `}
      <span ref={containerRef} className="relative inline-block">
        <span ref={emojiRef} className="inline-block">
          🥳
        </span>
      </span>
    </span>
  )
}
